module.exports = __webpack_public_path__ + "img/dianzan.5165ad8e.png";